module.exports = require("babel-register");


//////////////////
// WEBPACK FOOTER
// external "babel-register"
// module id = 28
// module chunks = 0